module.exports = __webpack_public_path__ + "static/media/itg_logo.066587b7.svg";